import React, { Component } from "react";

import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import { Link } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import NotificationsActiveOutlinedIcon from '@material-ui/icons/NotificationsActiveOutlined';

const styles = theme => ({
	[theme.breakpoints.down('sm')]:{
		bigcell: {
			maxWidth:'150px',
			minWidth:'50px'
		},
		medcell: {
			maxWidth:'50px',
			minWidth:'50px'
		},
		smallcell: {
			maxWidth:'15px',
			minWidth:'15px'
		},
	},
	[theme.breakpoints.up('md')]:{
		bigcell: {
			maxWidth:'150px',
			minWidth:'50px'
		},
		medcell: {
			maxWidth:'50px',
			minWidth:'50px'
		},
		smallcell: {
			maxWidth:'50px',
			minWidth:'50px'
		},
	},
	setoverflow:{
		overflow:'hidden',
		display: 'block'
	}
});

class AlertRow extends Component {
	constructor() {
		super();
		
		this.handleSolveAlert=this.handleSolveAlert.bind(this);
	}
	
	handleSolveAlert(e){
//		console.log("AlertRow.handleSolveAlert: "+this.props.id);
		this.props.handleSolveAlert(this.props.id);
	}
	
	render() {
		let date = this.props.date ? new Intl.DateTimeFormat('es-ES', {}).format(new Date(this.props.date)) : "";
		let activeColor = this.props.active ? "#F00" : "#B4B4B4";
		return (
			<TableRow hover key={this.props.id}>
				<TableCell><span className={this.props.classes.setoverflow}>{this.props.id}</span></TableCell>
				<TableCell><span className={this.props.classes.setoverflow}>{this.props.message}</span></TableCell>
				<TableCell><span className={this.props.classes.setoverflow}>{this.props.reference}</span></TableCell>
				<TableCell><span className={this.props.classes.setoverflow}>{date}</span></TableCell>
				<TableCell><span className={this.props.classes.setoverflow}><Tooltip title="Alert solved"><NotificationsActiveOutlinedIcon style={{ fontSize: "22px", color: activeColor, cursor: "pointer" }} onClick={() => { this.handleSolveAlert(); }}/></Tooltip></span></TableCell>
			</TableRow>
		);
	}
}

export default withStyles(styles)(AlertRow);